var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-view',{staticClass:"stream-modal",attrs:{"value":true,"modal":"","scrollable":false}},[(_vm.loading)?_c('div',{staticClass:"d-center local-loading-box"},[_c('base-spinner',{attrs:{"size":"72px"}})],1):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }